var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7065_92791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.63281 14.7625V7.58594C5.63281 7.32694 5.7357 7.07854 5.91884 6.8954C6.10198 6.71226 6.35037 6.60937 6.60938 6.60938H26.1406C26.3996 6.60938 26.648 6.71226 26.8312 6.8954C27.0143 7.07854 27.1172 7.32694 27.1172 7.58594V14.76C27.1172 25.0359 18.4124 28.4404 16.6753 29.0178C16.4807 29.085 16.2693 29.085 16.0747 29.0178C14.3376 28.4429 5.63281 25.042 5.63281 14.7625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 17.3516V12.4688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 23.2109C17.184 23.2109 17.8398 22.5551 17.8398 21.7461C17.8398 20.9371 17.184 20.2812 16.375 20.2812C15.566 20.2812 14.9102 20.9371 14.9102 21.7461C14.9102 22.5551 15.566 23.2109 16.375 23.2109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7065_92791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.25,
    height: 31.25,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.046ffce5.svg";
export { ForwardRef as ReactComponent };